var map = {
	"./hammer.static.js": 836,
	"./maps.static.css": 837,
	"./moment-timezone-with-data-2012-2022.static.js": 838,
	"./moment.static.js": 839,
	"./react-dom.static.js": 840,
	"./react-with-addons.static.js": 841,
	"./rome.static.css": 842,
	"./rome.static.js": 843
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 835;